import React from 'react';

const Page = ({ children, ...props}) => {
    return (
        <div className='pageContainer p-3' style={{minHeight:"520px", marginTop:"65px"}}>
            {children}
        </div>
    )
}
export default Page;